import { wrapperBuilder } from './build';
const variables = wrapperBuilder.getVariablesRegisterInstance();

variables.addVariable('identityDocuments', { startValue: undefined });
variables.addVariable('lastMainScanId', {
  startValue: undefined,
  persist: true,
});
